module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "box",
      "src": "images/box.jpg"
    }
  }), _c('img', {
    staticClass: "image_intext",
    attrs: {
      "alt": "",
      "id": "back",
      "src": "images/back.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("GETTING THE"), _c('br'), _vm._v("MOST OUT OF"), _c('br'), _c('i', [_vm._v("PRAYER AND LISTENING")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("F")]), _c('b', [_vm._v("or many people, ")]), _vm._v("prayer is a way to ask God to do what they want done. While requests are important, prayer also includes listening as we come together with God to know the “mind of Christ” about ourselves, our situations, and the people in our life ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Corinthians+2%3A16&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("1 Corinthians 2:16")]), _vm._v("). In this way prayer becomes a way of connecting with God. Through this two-way conversation God can “train [us] to be godly” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=1+Timothy+4%3A7&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("1 Timothy 4:7")]), _vm._v("). God created us for a relationship with him and wants to make us into the “same kind of thing as himself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-001",
      "id": "ap_ntf-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Here on this earth, we become disciples of Jesus and “share in the life of Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-002",
      "id": "ap_ntf-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" This transformation of your soul is “the hope to which he has called you” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ephesians+1%3A18&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Ephesians 1:18")]), _vm._v(") or, more poetically, “Christ in you, the hope of glory” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Colossians+1%3A27&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Colossians 1:27")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But if we’ve tried to be Christlike, this can seem like a cruel joke. How do we become people who automatically love our enemies and don’t grab the credit? Who naturally gives up power instead of wanting to take control? Some of us have been waiting a long time to become the tenderhearted, conscientious person our family always wished we’d become.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("THE SPIRITUAL FORMATION OF YOUR SOUL")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The key to this transformation—obedience—comes not from trying to be good. Trying to be good generally makes us obnoxious. When we succeed, we subtly look down on those who don’t do as well. When we don’t succeed, we beat ourselves up and obsess on our lack of spirituality. The enemy has won either way because we remain constantly focused on self instead of setting our hearts on things above.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So if trying doesn’t work, what does? Through the work of the Holy Spirit, we copy Jesus in the behind-the-scenes, everyday activities he did to connect with God. As we let these activities become habits, we slowly are trained to have the heart of Jesus and behave as he did. As we do the connecting, God does the perfecting.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("HOW SPIRITUAL DISCIPLINES WORK")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We connect with God through spiritual disciplines or exercises. Prayer and listening, the topics of this Bible study, are two of them. Other disciplines include solitude, silence, Bible study, Scripture meditation, worship, celebration, prayer, service, secrecy, reflection, confession, community, and submission. It has been said that a spiritual discipline is anything that helps us practice “how to become attentive to that small voice and willing to respond when we hear it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-003",
      "id": "ap_ntf-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("How do spiritual disciplines (or exercises) help us connect with God?")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("They build our relationship with God as we acquaint ourselves with the ways of God. (It’s possible, of course, to do these disciplines in a legalistic way and never bond with Christ.)")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("They build our trust in Christ. Some of the disciplines are uncomfortable. We have to go out on a limb. We try fasting and we don’t die. We serve someone, and it turns out to be fun and enriching.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("They force us to make “little decisions” that multiply. Our little decision to abstain from watching a television show helps us to deny ourselves and love others in all sorts of ways.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("They reorganize our impulses so that obedience is automatic. For example, if we have a spiritual discipline of practicing the presence of God, we may learn to automatically pray the breath prayer “Into thy hands” when someone opposes us. Without our realizing it, our opponent is no longer an adversary but a person God is dealing with or perhaps even speaking through in some way.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("They help us eventually behave like Christ—but this is by God’s miraculous work, not our direct effort. “The Christian thinks any good he does comes from the Christ-life inside him. [The Christian] does not think God will love us because we are good, but that God will "), _c('i', [_vm._v("make us good because He loves us.")]), _vm._v("”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-004",
      "id": "ap_ntf-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("They teach us to trust that God will do the work in our inner being through the power of the Spirit ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ephesians+3%3A16&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Ephesians 3:16")]), _vm._v("). Our spirituality is not about us; it’s the work of God in us. We get to cooperate in God’s “family business” of transforming the world.")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("HOW WE GET SPIRITUAL DISCIPLINES WRONG")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Spiritual exercises must be done with the goal of connecting, not for any sake of their own or any desire to check them off a list of to-do items. If we read our Bible just so we can get it done, or because we’ve heard this will help us have a great day, we’ll be anxious to get all the Bible study questions finished or to get to the bottom of the page of today’s reading. But if our goal in Bible reading is to connect with God, we may pause whenever we sense God speaking to us. Then we will study the passage further, comparing it with other sections. We’ll stop and meditate on it. We may pray certain phrases back to God, indicating our needs or our wishes or our questions. We may choose to read that passage day after day for a month because God keeps using it to speak to us.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After such a session, we will have a stronger desire to connect with God. That “little choice” we made to connect will leave us slightly different for life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The exercise or discipline is helpful because it helps us practice connecting with God. If we want to play the piano well or swing a tennis racket well, we have to practice certain exercises over and over. In life with God, we get good at connecting on an everyday basis by devoting time to developing the skills needed. Good baseball players train behind the scenes by practicing their batting day after day, with no crowds watching."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-005",
      "id": "ap_ntf-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" That’s what spiritual disciplines or exercises are about. If we can hear God in prayer and in practicing the divine presence, we’ll more likely hear God in a board meeting or an altercation with a recalcitrant teen when passions run high.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("THE DISCIPLINE OF PRAYER")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Prayer is, no doubt, the most common spiritual discipline, used even by those who aren’t sure there’s anyone listening! In crisis, folks who wouldn’t identify themselves as Christians or who don’t attend church find themselves praying. This indicates a distinct human tendency to talk to God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("While some other disciplines seem mysterious and laborious, folks almost fall into praying without thinking about it. Until we make it too complicated, that is. Over the years people have developed formulas, techniques, and foolproof schemes to get God to say yes to their prayers. It’s as if God has been reduced to a vending machine, and people search for the right sort of coin to insert so that goodies will appear in the tray to be grabbed. Such frantic grasping misses the point of prayer, which is so well explained by Oswald Chambers: “We look upon prayer simply as a means of getting things for ourselves, but the biblical purpose of prayer is that we may get to know God Himself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen4#ntf-006",
      "id": "ap_ntf-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Biblical prayer is about building a relationship with God. Knowing God himself teaches us to relate to God in an authentic way—not just doing the good things that good people are supposed to do.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We learn that God is transcendent; we learn to talk and listen to this all-knowing, all-powerful Creator in ways God teaches us. The studies in this guide outline some of those ways. We also learn that God is immanent and that we can reach out to this God who is as close as our breath.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("HOW DO THESE STUDIES WORK?")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These studies examine examples, how-to activities, and the results of connecting with God through prayer and practicing God’s presence. One question in each of the six studies calls for actual praying to be done in the session. Look for these questions and use them. This will demonstrate the pattern that Bible study leads us to respond to God, especially through prayer.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Now or Later” sections include activities or thoughts to experiment with in order to experience the spiritual exercise studied. At the end of the study look at these exercises and choose the one that fits you best, according to your personality or your current needs. Think of a time to try it and tell the group.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Perhaps you’ll read the exercise and think it’s too elementary or too difficult for you. Adapt it as needed. Or maybe you think you can guess what you’ll experience, so you don’t have to do it. The point is to experience it. Go ahead and try.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("USING THESE STUDIES IN RETREATS")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("These studies work well for an individual taking a personal retreat. Simply do the studies at your own pace, and do not rush them. Allow enough time to do the transformation exercises as well. Don’t feel you have to do all the studies. In fact, you may wish to focus only on one discipline and use only those studies.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A group wishing to explore certain disciplines can also use one of these studies the same way. Be sure to allow time for participants to do the transformation exercises. Some exercises may be done as a group. Others may be done individually, with group members reporting back to each other about how they heard God during the exercise.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For either type of retreat, allow plenty of time for pondering. May these studies help you move a few steps closer to living your life in union with God.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("SUGGESTIONS FOR INDIVIDUAL STUDY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" As you begin each study, pray that God will speak to you through his Word.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Read the introduction to the study and respond to the personal reflection question or exercise. This is designed to help you focus on God and on the theme of the study.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Each study deals with a particular passage—so that you can delve into the author’s meaning in that context. Read and reread the passage to be studied. The questions are written using the language of the New International Version, so you may wish to use that version of the Bible. The New Revised Standard Version is also recommended.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" This is an inductive Bible study, designed to help you discover for yourself what Scripture is saying. The study includes three types of questions. "), _c('i', [_vm._v("Observation ")]), _vm._v("questions ask about the basic facts: who, what, when, where, and how. "), _c('i', [_vm._v("Interpretation ")]), _vm._v("questions delve into the meaning of the passage. "), _c('i', [_vm._v("Application ")]), _vm._v("questions help you discover the implications of the text for growing in Christ. These three keys unlock the treasures of Scripture.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Write your answers to the questions in the spaces provided or in a personal journal. Writing can bring clarity and deeper understanding of yourself and of God’s Word.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('b', [_vm._v("5.")]), _vm._v(" It might be good to have a Bible dictionary handy. Use it to look up any unfamiliar words, names, or places.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Use the prayer suggestion to guide you in thanking God for what you have learned and to pray about the applications that have come to mind.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("7.")]), _vm._v(" You may want to go on to the suggestion under “Now or Later,” or you may want to use that idea for your next study.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("SUGGESTIONS FOR MEMBERS OF A GROUP STUDY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Come to the study prepared. Follow the suggestions for individual study mentioned above. You will find that careful preparation will greatly enrich your time spent in group discussion.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Be willing to participate in the discussion. The leader of your group will not be lecturing. Instead, he or she will be encouraging the members of the group to discuss what they have learned. The leader will be asking the questions that are found in this guide.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Stick to the topic being discussed. Your answers should be based on the verses which are the focus of the discussion and not on outside authorities such as commentaries or speakers. These studies focus on a particular passage of Scripture. Only rarely should you refer to other portions of the Bible. This allows for everyone to participate in in-depth study on equal ground.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Be sensitive to the other members of the group. Listen attentively when they describe what they have learned. You may be surprised by their insights! Each question assumes a variety of answers. Many questions do not have “right” answers, particularly questions that aim at meaning or application. Instead the questions push us to explore the passage more thoroughly.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When possible, link what you say to the comments of others. Also, be affirming whenever you can. This will encourage some of the more hesitant members of the group to participate.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Be careful not to dominate the discussion. We are sometimes so eager to express our thoughts that we leave too little opportunity for others to respond. By all means participate! But allow others to also.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Expect God to teach you through the passage being discussed and through the other members of the group. Pray that you will have an "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("enjoyable and profitable time together, but also that as a result of the study you will find ways that you can take action individually and/or as a group.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("7.")]), _vm._v(" Remember that anything said in the group is considered confidential and should not be discussed outside the group unless specific permission is given to do so.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("8.")]), _vm._v(" If you are the group leader, you will find additional suggestions at the back of the guide.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0